import axios from "axios";

export const getResendMail = async (id: string | undefined): Promise<string> => {
    const response = await axios.get(`/booking/resend/${id}`, {
        params: {
            mailAdress: ''
        }
    });
    return response.data;
};

export default getResendMail;
